import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ICalendarEventResource } from "../types";

export interface ICalendarEventDeleteFollowingRecurrenciesMutationParameters {
    calendarEvent: RelationalValue<ICalendarEventResource>;
}

export type ICalendarEventDeleteFollowingRecurrenciesMutationResult = void;

export const calendarEventDeleteFollowingRecurrenciesMutation: IApiMutationFunction<
    ICalendarEventDeleteFollowingRecurrenciesMutationParameters
> = ({ calendarEvent }) => {
    return {
        method: "DELETE",
        url: `/calendar-events/${mapRelationalValue(calendarEvent)}/recurrencies/following`,
    };
};

export const useCalendarEventDeleteFollowingRecurrenciesMutation = createApiMutationHook<
    ICalendarEventDeleteFollowingRecurrenciesMutationParameters,
    ICalendarEventDeleteFollowingRecurrenciesMutationResult
>(calendarEventDeleteFollowingRecurrenciesMutation);
